import styled from "styled-components";
import DesignConstants from "../../../../constants/DesignConstants";

export const AdditionalInfoWrapper = styled.div`
    margin-top: ${DesignConstants.SPACES.M};
    display: flex;
    flex-direction: column;
    text-align: center;
    bottom: ${DesignConstants.SPACES.XXXL};
    max-width: calc(${process.env.REACT_APP_UPPER_GRID_STEP_BORDER}px - ${DesignConstants.SPACES.L});
    width: 100%;
    gap: ${DesignConstants.SPACES.XS};
    z-index: 1;

    &.bottom-zero {
        bottom: ${DesignConstants.SPACES.S};
    }

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        flex-wrap: wrap;
        padding: ${DesignConstants.SPACES.XS} ${DesignConstants.SPACES.XS} ${DesignConstants.SPACES.S}
            ${DesignConstants.SPACES.XS};
    }
`;
